export default __webpack_public_path__ + "static/media/checkmark.62951caa.svg";